import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getPrivateRooms = state => state.privateRooms
const getCommonArea = state => state.commonArea

export const selectPrivateRoomsFetching = state => path(['privateRooms', 'isFetching'], state)
export const selectCommonAreaFetching = state => path(['commonArea', 'isFetching'], state)

export const selectPrivateRooms = createSelector(getPrivateRooms, rooms => {
    if (!(isEmpty(rooms.entities) || isEmpty(rooms.result))) {
        const items = rooms.entities.privateRooms
        return items
    } else {
        return []
    }
})

export const selectCommonArea = createSelector(getCommonArea, rooms => {
    if (!(isEmpty(rooms.entities) || isEmpty(rooms.result))) {
        const items = rooms.entities.commonArea
        return items
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/omnitecSelectors/omnitecRooms.js